export default class Permission {
    getPermissions() {
        return window.localStorage.getItem('permissions');
    }

    can(ability) {
        const permissions = this.permissions();

        if (permissions.is_tenant_admin && ability === 'view_brands') {
            return false;
        }

        if (permissions.is_app_admin || permissions.is_tenant_admin) {
            return true
        }

        return this.aliasesFor(ability).some(candidate => !!permissions[candidate]);
    }
    
    isAppAdmin() {
        return this.permissions().is_app_admin
    }

    isAdmin(){
        return !!this.permissions().is_app_admin || !!this.permissions().is_tenant_admin;
    }

    isOnlyDepartmentManager(){
        if (this.permissions()['access_all_departments']){
            return false;
        }

        return this.permissions()['access_own_departments'] || false
    }

    permissions() {
        return JSON.parse(this.getPermissions() || '{}');
    }

    aliasesFor(ability) {
        if (!ability) {
            return [];
        }

        const normalized = String(ability).trim();

        if (!normalized) {
            return [];
        }

        const splitIndex = normalized.indexOf('_');

        if (splitIndex === -1) {
            return [normalized];
        }

        const action = normalized.slice(0, splitIndex).replace(/-/g, '_');
        const resource = normalized.slice(splitIndex + 1);
        const resourceVariants = [...new Set([
            resource,
            resource.replace(/-/g, '_'),
            resource.replace(/_/g, '-'),
        ])];

        const actionAliases = this.actionAliases(action);
        const aliases = [];

        actionAliases.forEach(candidateAction => {
            resourceVariants.forEach(candidateResource => {
                aliases.push(`${candidateAction}_${candidateResource}`);
            });
        });

        return [...new Set([normalized, ...aliases])];
    }

    actionAliases(action) {
        switch (action) {
            case 'view':
            case 'index':
            case 'show':
            case 'lists':
                return ['view', 'index', 'show', 'lists'];
            case 'create':
            case 'store':
                return ['create', 'store'];
            case 'update':
            case 'edit':
                return ['update', 'edit'];
            case 'delete':
            case 'destroy':
                return ['delete', 'destroy'];
            default:
                return [action];
        }
    }
}
